import Draggable from 'react-draggable'
import {
  Box,
  Button,
  Divider,
  IconButton,
  Popover,
  SvgIcon,
  TextField,
  Typography,
} from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import {
  CodeValidationAgent,
  CodeValidationStatusColor,
  CodeValidationDisciplineColor,
} from '../../models/Validation'
import { Fragment, MouseEvent, useCallback, useMemo, useState } from 'react'
import { getEnums } from '../../utils/Common'
import {
  setCodeValidationAgent,
  setShowCodeValidationOptionsModal,
} from '../../actions/validation'

const SpacialAILogoSvgIcon = () => (
  <SvgIcon sx={{ height: '0.5em', width: '3.5em' }}>
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 67 10' fill='none'>
      <path
        d='M18.145 5.98572C17.981 5.85563 17.7893 5.74915 17.543 5.65187C17.178 5.50739 15.358 5.05555 14.9125 4.92719C14.7047 4.86732 14.5118 4.77292 14.3403 4.64629C14.159 4.51275 14.0583 4.35734 14.0318 4.17257C13.9604 3.67525 14.1101 3.26887 14.4767 2.96438C14.6724 2.80148 14.9107 2.68982 15.2049 2.62247C15.4224 2.57297 15.6504 2.54764 15.8824 2.54764C16.0424 2.54764 16.2087 2.55973 16.3774 2.58333C17.1337 2.68924 17.6443 3.0346 17.939 3.63899C17.9591 3.68043 17.9597 3.68331 17.9649 3.70115L17.9695 3.71669L17.9758 3.73799H17.9977C18.0426 3.73626 18.4749 3.73684 18.5278 3.73684H18.5675L18.5549 3.69885C18.5462 3.6718 18.5382 3.64762 18.5313 3.62517C18.518 3.58258 18.5065 3.54574 18.4921 3.51005C18.2435 2.87459 17.7721 2.42849 17.0923 2.18386C16.8298 2.08946 16.538 2.03133 16.2007 2.00543C16.0844 1.99679 15.9698 1.99219 15.8611 1.99219C15.3781 1.99219 14.9568 2.07795 14.5717 2.25351C13.9276 2.54822 13.5506 3.01734 13.4516 3.64762C13.3796 4.10638 13.4516 4.48109 13.672 4.79307C13.8211 5.00432 14.0324 5.17124 14.3363 5.3186C14.7755 5.53157 16.7072 6.00932 17.1867 6.14228C17.387 6.19812 17.5729 6.29252 17.7398 6.42318C17.8987 6.54751 18 6.69889 18.042 6.8733C18.1261 7.22499 18.084 7.55424 17.916 7.85125C17.7536 8.13847 17.4946 8.34051 17.1234 8.46829C16.8177 8.57363 16.4908 8.62716 16.1512 8.62716C15.9163 8.62716 15.6682 8.60183 15.4138 8.55118C14.6034 8.39116 14.0744 7.91399 13.8413 7.13232C13.8338 7.10642 13.8217 7.08224 13.8119 7.06095C13.8073 7.05174 13.8033 7.0431 13.7998 7.03447L13.7923 7.0172H13.2576L13.2536 7.04137C13.2524 7.04886 13.2513 7.05461 13.2501 7.05979C13.2478 7.07015 13.2467 7.07879 13.2461 7.08742C13.2461 7.10009 13.2467 7.1139 13.2495 7.12656C13.4355 7.94737 13.8798 8.52528 14.5706 8.84416C15.0633 9.07153 15.5773 9.18665 16.0994 9.18665C16.508 9.18665 16.9276 9.11585 17.3461 8.97598C18.1767 8.69796 18.6458 8.06825 18.666 7.20197C18.6786 6.67126 18.5083 6.27294 18.145 5.98572Z'
        fill='#0C083B'
        stroke='black'
        strokeWidth='0.2'
      />
      <path
        d='M33.7156 3.38124C34.2935 2.83557 34.9768 2.5587 35.7469 2.5587C35.8799 2.5587 36.0175 2.56676 36.1556 2.58345C37.1077 2.69627 37.8421 3.18093 38.3389 4.02361C38.3694 4.07542 38.3982 4.12952 38.4258 4.1819C38.439 4.20723 38.4523 4.23198 38.4655 4.25673L38.4736 4.2717H39.0952L39.078 4.23141C39.078 4.23141 39.0411 4.14506 39.0359 4.13413C38.6543 3.21259 37.9993 2.56906 37.0881 2.2214C36.6834 2.06656 36.2586 1.98828 35.8264 1.98828C35.6002 1.98828 35.3682 2.00958 35.1362 2.05217C33.9119 2.27551 33.0353 2.95414 32.5293 4.06851C32.2191 4.75348 32.1362 5.50118 32.2841 6.29149C32.4971 7.43233 33.1216 8.27386 34.1393 8.79133C34.6464 9.0492 35.1892 9.17986 35.7515 9.17986C36.0134 9.17986 36.2834 9.15108 36.5539 9.09467C37.7126 8.85292 38.5455 8.16623 39.0279 7.05359C39.0446 7.0156 39.0515 6.99948 39.0785 6.92292L39.0918 6.88436H38.4672L38.4592 6.8999C38.4592 6.8999 38.42 6.97588 38.3878 7.04265C38.1909 7.44615 37.8991 7.78863 37.5209 8.06089C37.0161 8.4241 36.4434 8.60886 35.8189 8.60886C35.7297 8.60886 35.6376 8.60484 35.5461 8.59735C34.5572 8.51619 33.7893 8.05513 33.2649 7.22569C32.8597 6.58504 32.7193 5.85345 32.8476 5.05106C32.9541 4.38509 33.2459 3.82273 33.7151 3.37951L33.7156 3.38124Z'
        fill='#0C083B'
      />
      <path
        d='M35.8264 1.98828C36.2586 1.98828 36.6834 2.06656 37.0881 2.2214C37.9993 2.56906 38.6543 3.21259 39.0359 4.13413C39.0411 4.14506 39.078 4.2314 39.078 4.2314L39.0952 4.2717H38.4736L38.4655 4.25673C38.4523 4.23198 38.439 4.20723 38.4258 4.1819C38.3982 4.12952 38.3694 4.07542 38.3389 4.02361C37.8421 3.18093 37.1077 2.69627 36.1556 2.58345C36.0175 2.56676 35.8799 2.5587 35.7469 2.5587C34.9768 2.5587 34.2935 2.83557 33.7156 3.38124L33.7151 3.37951C33.2459 3.82273 32.9541 4.38509 32.8476 5.05106C32.7193 5.85345 32.8597 6.58504 33.2649 7.22569C33.7893 8.05513 34.5572 8.51619 35.5461 8.59735C35.6376 8.60483 35.7297 8.60886 35.8189 8.60886C36.4434 8.60886 37.0161 8.4241 37.5209 8.06089C37.8991 7.78863 38.1909 7.44615 38.3878 7.04265C38.42 6.97588 38.4592 6.8999 38.4592 6.8999L38.4672 6.88436H39.0918L39.0785 6.92292C39.0515 6.99948 39.0446 7.0156 39.0279 7.05359C38.5455 8.16623 37.7126 8.85292 36.5539 9.09467C36.2834 9.15108 36.0134 9.17986 35.7515 9.17986C35.1892 9.17986 34.6464 9.0492 34.1393 8.79133C33.1216 8.27386 32.4971 7.43233 32.2841 6.29149C32.1362 5.50118 32.2191 4.75348 32.5293 4.06851C33.0353 2.95414 33.9119 2.27551 35.1362 2.05217C35.3682 2.00958 35.6002 1.98828 35.8264 1.98828ZM35.8264 1.98828V2.00267'
        stroke='black'
        strokeWidth='0.2'
      />
      <path
        d='M50.555 8.50617C50.5544 8.04051 50.5429 2.10547 50.5429 2.10547H49.9863L49.995 9.0553H54.0673V8.50617H50.5544H50.555Z'
        fill='#0C083B'
        stroke='black'
        strokeWidth='0.2'
      />
      <path
        d='M40.457 2.10547L40.4651 9.05702H41.0136V2.10547H40.457Z'
        fill='#0C083B'
        stroke='black'
        strokeWidth='0.2'
      />
      <path
        d='M25.2808 4.08847C25.2094 3.26305 24.8059 2.67306 24.0824 2.33518C23.7428 2.17689 23.3497 2.09861 22.8805 2.09573C22.7453 2.09516 20.1758 2.10379 20.1758 2.10379L20.1867 9.06801L20.7525 9.06283C20.7525 9.06283 20.7508 3.83348 20.7508 2.65809C20.7508 2.65809 22.5519 2.65809 22.8535 2.65809C23.1396 2.65809 23.3974 2.69608 23.6415 2.77379C24.2464 2.96547 24.6471 3.47718 24.6868 4.10861C24.7081 4.44074 24.6735 4.70436 24.5797 4.93806C24.3633 5.47509 23.9385 5.79858 23.3174 5.89931C23.1424 5.92809 22.9657 5.9327 22.8166 5.93327C22.5208 5.935 21.5382 5.935 21.5382 5.935V6.49909C21.5382 6.49909 22.5927 6.49909 22.8587 6.49449C23.1419 6.49046 23.3802 6.46628 23.5885 6.42139C24.2522 6.27748 24.7403 5.91658 25.0396 5.34904C25.2394 4.97087 25.3205 4.54607 25.2808 4.08732V4.08847Z'
        fill='#0C083B'
        stroke='black'
        strokeWidth='0.2'
      />
      <path
        d='M28.8474 2.09375H28.1153L25.2344 9.05854H25.856C25.856 9.05854 28.1504 3.44929 28.4796 2.71713C28.7145 3.28928 29.6849 5.61241 29.9296 6.20816H27.8113L27.8039 6.226L27.6018 6.72447L27.5857 6.76419H27.6283L30.1581 6.77282L31.1044 9.062H31.7272L28.8463 2.0949L28.8474 2.09375Z'
        fill='#0C083B'
        stroke='black'
        strokeWidth='0.2'
      />
      <path
        d='M45.8826 2.09375H45.1504L42.2695 9.05854H42.8912C42.8912 9.05854 45.1855 3.44929 45.5148 2.71713C45.7496 3.28928 45.9931 3.87121 46.228 4.43473C46.4697 5.01378 46.7195 5.61241 46.9647 6.20873H44.8465L44.6209 6.76419L47.1932 6.77282L48.1395 9.062H48.7623L45.8814 2.0949L45.8826 2.09375Z'
        fill='#0C083B'
        stroke='black'
        strokeWidth='0.2'
      />
      <path
        d='M65.4434 2.23145L65.452 9.183H66V2.23145H65.4434Z'
        fill='#1705E5'
        stroke='#1705E5'
        strokeWidth='0.2'
      />
      <path
        d='M61.0935 2.21973H60.3614L57.4805 9.18452H58.1021C58.1021 9.18452 60.3965 3.57527 60.7257 2.8431C60.9606 3.41525 61.204 3.99719 61.4389 4.5607C61.6806 5.13976 61.9305 5.73839 62.1757 6.33471H60.0574L59.8318 6.89017L62.4042 6.8988L63.3505 9.18797H63.9733L61.0924 2.22088L61.0935 2.21973Z'
        fill='#1705E5'
        stroke='#1705E5'
        strokeWidth='0.2'
      />
      <path
        d='M4.79562 0.256599C4.60819 0.106596 4.34181 0.106595 4.15438 0.256598L0.192493 3.4274C0.070823 3.52478 0 3.67217 0 3.82801V8.90794C0 9.19133 0.229727 9.42105 0.513111 9.42105H8.43689C8.72027 9.42105 8.95 9.19133 8.95 8.90794V3.82801C8.95 3.67217 8.87918 3.52478 8.75751 3.4274L4.79562 0.256599Z'
        fill='url(#paint0_linear_3019_1494)'
      />
      <path
        d='M4.6471 8.16236C4.73872 8.16236 4.80417 8.10097 4.81725 8.00011C4.95687 6.81616 5.01359 6.78108 6.21342 6.59253C6.3225 6.57499 6.38794 6.51798 6.38794 6.42151C6.38794 6.32943 6.3225 6.26804 6.23524 6.2505C5.01795 6.01371 4.95687 6.02248 4.81725 4.84291C4.80417 4.74205 4.73872 4.68066 4.6471 4.68066C4.55547 4.68066 4.49003 4.74205 4.47694 4.83852C4.3286 6.04002 4.28497 6.08387 3.06332 6.2505C2.97606 6.25927 2.90625 6.32943 2.90625 6.42151C2.90625 6.5136 2.9717 6.57499 3.05896 6.59253C4.28933 6.82932 4.32423 6.82932 4.47694 8.00888C4.49003 8.10097 4.55547 8.16236 4.6471 8.16236Z'
        fill='white'
      />
      <path
        d='M3.25545 5.02945C3.31042 5.02945 3.34969 4.99261 3.35754 4.9321C3.44131 4.22173 3.47534 4.20068 4.19524 4.08755C4.26069 4.07702 4.29995 4.04282 4.29995 3.98494C4.29995 3.92969 4.26069 3.89285 4.20833 3.88233C3.47796 3.74025 3.44131 3.74552 3.35754 3.03778C3.34969 2.97726 3.31042 2.94043 3.25545 2.94043C3.20047 2.94043 3.1612 2.97726 3.15335 3.03515C3.06435 3.75604 3.03817 3.78235 2.30518 3.88233C2.25282 3.88759 2.21094 3.92969 2.21094 3.98494C2.21094 4.04019 2.2502 4.07702 2.30256 4.08755C3.04078 4.22962 3.06173 4.22962 3.15335 4.93736C3.1612 4.99261 3.20047 5.02945 3.25545 5.02945Z'
        fill='white'
      />
      <path
        d='M6.3897 5.72569C6.42635 5.72569 6.45253 5.70113 6.45776 5.66079C6.51361 5.18721 6.5363 5.17317 7.01623 5.09775C7.05986 5.09074 7.08604 5.06793 7.08604 5.02935C7.08604 4.99251 7.05986 4.96796 7.02495 4.96094C6.53804 4.86622 6.51361 4.86973 6.45776 4.39791C6.45253 4.35756 6.42635 4.33301 6.3897 4.33301C6.35305 4.33301 6.32687 4.35756 6.32163 4.39615C6.2623 4.87675 6.24485 4.89429 5.75619 4.96094C5.72128 4.96445 5.69336 4.99251 5.69336 5.02935C5.69336 5.06618 5.71954 5.09074 5.75444 5.09775C6.24659 5.19247 6.26055 5.19247 6.32163 5.6643C6.32687 5.70113 6.35305 5.72569 6.3897 5.72569Z'
        fill='white'
      />
      <defs>
        <linearGradient
          id='paint0_linear_3019_1494'
          x1='7.06579'
          y1='1.41316'
          x2='0.471052'
          y2='10.5987'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#766AFC' />
          <stop offset='1' stopColor='#1D0CE7' />
        </linearGradient>
      </defs>
    </svg>
  </SvgIcon>
)

const EllipsisSvgIcon = () => (
  <SvgIcon sx={{ height: '0.75em', width: '0.75em' }}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='4'
      viewBox='0 0 13 3'
      fill='none'
    >
      <circle cx='1.5' cy='1.5' r='1.5' fill='#06004A' />
      <circle cx='6.5' cy='1.5' r='1.5' fill='#06004A' />
      <circle cx='11.5' cy='1.5' r='1.5' fill='#06004A' />
    </svg>
  </SvgIcon>
)

const ArchitectureSvgIcon = () => (
  <SvgIcon sx={{ height: '10px' }}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='10'
      height='15'
      viewBox='0 0 10 15'
      fill='none'
    >
      <path
        d='M7.65279 4.16667C7.65279 3.08333 6.90877 2.16667 5.88132 1.81667V0H4.10984V1.81667C3.08238 2.16667 2.33836 3.08333 2.33836 4.16667C2.33836 5.55 3.52525 6.66667 4.99558 6.66667C6.4659 6.66667 7.65279 5.55 7.65279 4.16667ZM4.99558 5C4.50842 5 4.10984 4.625 4.10984 4.16667C4.10984 3.70833 4.50842 3.33333 4.99558 3.33333C5.48273 3.33333 5.88132 3.70833 5.88132 4.16667C5.88132 4.625 5.48273 5 4.99558 5Z'
        fill='#06004A'
      />
      <path
        d='M7.44907 6.56667C7.01506 6.95834 6.47476 7.24167 5.88132 7.38334L8.33481 13.7167L9.76971 15L10 13.15L7.44907 6.56667Z'
        fill='#06004A'
      />
      <path
        d='M0 13.15L0.221435 15L1.65633 13.7167L4.10983 7.38334C3.50752 7.24167 2.97608 6.95834 2.54207 6.56667L0 13.15Z'
        fill='#06004A'
      />
    </svg>
  </SvgIcon>
)

const EngineeringSvgIcon = () => (
  <SvgIcon sx={{ height: '10px' }}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
    >
      <path
        d='M11.988 2.91669C11.9788 2.80986 11.7404 2.60472 11.6395 2.56813C11.5383 2.53131 11.4251 2.55637 11.349 2.63206L9.82259 4.15846L7.83996 2.17583L9.3969 0.624747C9.4731 0.548914 9.49795 0.436089 9.46125 0.335495C9.42417 0.234701 9.17972 0.0211681 9.07227 0.011914C8.12672 -0.0692465 7.20025 0.267076 6.53041 0.934493C5.61301 1.84852 5.37006 3.18325 5.80027 4.32095C5.75325 4.36042 5.70685 4.40224 5.66108 4.44733L0.464019 9.33287C0.462186 9.33465 0.460378 9.3366 0.458395 9.33835C-0.152798 9.94727 -0.152798 10.938 0.458395 11.547C1.06969 12.1559 2.05691 12.1485 2.66801 11.5396C2.67064 11.5371 2.67305 11.5347 2.67546 11.532L7.53669 6.31415C7.581 6.2698 7.62215 6.22341 7.66094 6.17579C8.80324 6.60515 10.1439 6.3637 11.0621 5.44907C11.7318 4.7816 12.0696 3.85855 11.988 2.91669Z'
        fill='#06004A'
      />
    </svg>
  </SvgIcon>
)

const PermitValidationSvgIcon = () => (
  <SvgIcon sx={{ height: '10px' }}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='6'
      height='6'
      viewBox='0 0 6 6'
      fill='none'
    >
      <path
        d='M2.95172 5.90345C3.76681 5.90345 4.50474 5.57306 5.0389 5.0389C5.57306 4.50474 5.90345 3.76681 5.90345 2.95172C5.90345 2.13663 5.57306 1.3987 5.0389 0.864539C4.50474 0.330383 3.76681 0 2.95172 0C2.13663 0 1.3987 0.330383 0.864539 0.864539C0.330383 1.3987 0 2.13663 0 2.95172C0 3.76681 0.330383 4.50474 0.864539 5.0389C1.3987 5.57306 2.13663 5.90345 2.95172 5.90345Z'
        fill='#06004A'
      />
      <path
        d='M1.77148 2.95192L2.657 3.83744L4.42804 2.06641'
        stroke='white'
        strokeWidth='0.590345'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  </SvgIcon>
)

const AutoAgentSvgIcon = () => (
  <SvgIcon sx={{ height: '10px' }}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='6'
      height='8'
      viewBox='0 0 6 8'
      fill='none'
    >
      <path
        d='M0.195602 4.58151L2.74238 0.579437C2.8498 0.410629 3.11111 0.486722 3.11111 0.686811V3.35556C3.11111 3.46601 3.20065 3.55556 3.31111 3.55556H4.9492C5.11101 3.55556 5.20584 3.73769 5.11305 3.87025L2.58607 7.48022C2.47393 7.64041 2.22222 7.56107 2.22222 7.36553V5.08889C2.22222 4.97843 2.13268 4.88889 2.02222 4.88889H0.364335C0.206517 4.88889 0.110874 4.71466 0.195602 4.58151Z'
        fill='#06004A'
      />
    </svg>
  </SvgIcon>
)

const CodeValidationAgentDropdownIcons: Record<
  CodeValidationAgent,
  JSX.Element
> = {
  [CodeValidationAgent.Architecture]: <ArchitectureSvgIcon />,
  [CodeValidationAgent.Engineering]: <EngineeringSvgIcon />,
  [CodeValidationAgent.PermitValidation]: <PermitValidationSvgIcon />,
  [CodeValidationAgent.AutoAgent]: <AutoAgentSvgIcon />,
}

const SpacialAISvgIcon = ({
  fill,
  width,
  height,
}: {
  fill: string
  width: number
  height: number
}) => (
  <SvgIcon sx={{ width: `${width}px`, height: `${height}px` }}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='7'
      height='8'
      viewBox='0 0 7 8'
      fill='none'
    >
      <path
        d='M3.75076 0.200692C3.60417 0.0833708 3.39583 0.0833707 3.24924 0.200691L0.150554 2.68065C0.0553925 2.75681 0 2.87209 0 2.99397V6.96711C0 7.18875 0.179675 7.36842 0.401316 7.36842H6.59868C6.82032 7.36842 7 7.18875 7 6.96711V2.99397C7 2.87209 6.94461 2.75681 6.84945 2.68065L3.75076 0.200692Z'
        fill={fill}
      />
      <path
        d='M3.63499 6.38425C3.70665 6.38425 3.75784 6.33623 3.76808 6.25735C3.87728 5.33135 3.92164 5.30392 4.86005 5.15644C4.94536 5.14273 4.99655 5.09814 4.99655 5.02269C4.99655 4.95067 4.94536 4.90265 4.87712 4.88893C3.92505 4.70373 3.87728 4.71059 3.76808 3.78803C3.75784 3.70915 3.70665 3.66113 3.63499 3.66113C3.56333 3.66113 3.51215 3.70915 3.50191 3.7846C3.38589 4.72431 3.35176 4.75861 2.39628 4.88893C2.32804 4.89579 2.27344 4.95067 2.27344 5.02269C2.27344 5.09471 2.32462 5.14273 2.39287 5.15644C3.35518 5.34164 3.38247 5.34164 3.50191 6.26421C3.51215 6.33623 3.56333 6.38425 3.63499 6.38425Z'
        fill='white'
      />
      <path
        d='M2.54545 3.93367C2.58845 3.93367 2.61916 3.90486 2.6253 3.85753C2.69082 3.30194 2.71744 3.28548 3.28048 3.19699C3.33167 3.18876 3.36238 3.16201 3.36238 3.11674C3.36238 3.07353 3.33167 3.04472 3.29072 3.03649C2.71948 2.92537 2.69082 2.92948 2.6253 2.37594C2.61916 2.32861 2.58845 2.2998 2.54545 2.2998C2.50245 2.2998 2.47174 2.32861 2.4656 2.37388C2.39599 2.93771 2.37551 2.95829 1.80222 3.03649C1.76127 3.0406 1.72852 3.07353 1.72852 3.11674C1.72852 3.15995 1.75923 3.18876 1.80018 3.19699C2.37756 3.30811 2.39394 3.30811 2.4656 3.86165C2.47174 3.90486 2.50245 3.93367 2.54545 3.93367Z'
        fill='white'
      />
      <path
        d='M4.99775 4.47889C5.02641 4.47889 5.04689 4.45969 5.05098 4.42814C5.09466 4.05774 5.1124 4.04676 5.48777 3.98777C5.5219 3.98229 5.54237 3.96445 5.54237 3.93427C5.54237 3.90546 5.5219 3.88626 5.4946 3.88077C5.11377 3.80669 5.09466 3.80943 5.05098 3.44041C5.04689 3.40885 5.02641 3.38965 4.99775 3.38965C4.96908 3.38965 4.94861 3.40885 4.94451 3.43903C4.8981 3.81492 4.88446 3.82864 4.50226 3.88077C4.47496 3.88351 4.45312 3.90546 4.45312 3.93427C4.45312 3.96308 4.4736 3.98229 4.5009 3.98777C4.88582 4.06185 4.89674 4.06185 4.94451 4.43088C4.94861 4.45969 4.96908 4.47889 4.99775 4.47889Z'
        fill='white'
      />
    </svg>
  </SvgIcon>
)

const EnterSvgIcon = () => (
  <SvgIcon sx={{ width: '15px', height: '14px' }}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='14'
      viewBox='0 0 15 14'
      fill='none'
    >
      <path
        d='M9.88797 1L14 5.0877M14 5.0877L9.88797 9.1754M14 5.0877L5 5.0877C2.79086 5.0877 1 6.87856 1 9.0877L1 13'
        stroke='#1705E5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  </SvgIcon>
)

const PhotoSvgIcon = () => (
  <SvgIcon sx={{ width: '14px', height: '14px' }}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
    >
      <path
        d='M1 7.38157L2.77805 6.05134C3.28835 5.71114 3.97009 5.79141 4.38742 6.24084C5.32019 7.24536 6.40161 8.15861 7.875 8.15861C9.23293 8.15861 10.1328 7.65532 11 6.7881M1 1H11V11H1V1ZM9.125 4.125C9.125 4.81536 8.56536 5.375 7.875 5.375C7.18464 5.375 6.625 4.81536 6.625 4.125C6.625 3.43464 7.18464 2.875 7.875 2.875C8.56536 2.875 9.125 3.43464 9.125 4.125Z'
        stroke='black'
        strokeWidth='0.75'
      />
    </svg>
  </SvgIcon>
)

const LinkSvgIcon = () => (
  <SvgIcon sx={{ width: '14px', height: '14px' }}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='10'
      height='10'
      viewBox='0 0 10 10'
      fill='none'
    >
      <path
        d='M2.80339 3.84731L1.64013 5.01057C1.20569 5.44501 0.955856 6.03614 0.960422 6.6574C0.964988 7.27866 1.20935 7.87339 1.66441 8.3144C2.1054 8.76947 2.70025 9.01382 3.32141 9.01839C3.95674 9.02306 4.53387 8.7873 4.96834 8.35284L6.1316 7.18959M7.61744 5.73217L8.7807 4.56891C9.21515 4.13446 9.46498 3.54334 9.46041 2.92208C9.45585 2.30082 9.21148 1.70609 8.75642 1.26508C8.31554 0.824206 7.72079 0.579826 7.09953 0.57526C6.47827 0.570695 5.88707 0.806347 5.4526 1.2408L4.28934 2.40406M3.44641 6.52264L6.93618 3.03287'
        stroke='black'
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  </SvgIcon>
)

const GlobeSvgIcon = () => (
  <SvgIcon sx={{ width: '14px', height: '14px' }}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='11'
      height='12'
      viewBox='0 0 11 12'
      fill='none'
    >
      <path
        d='M10.1074 6.375C10.3145 6.375 10.4824 6.20711 10.4824 6C10.4824 5.79289 10.3145 5.625 10.1074 5.625V6.375ZM10.0449 6C10.0449 8.55432 7.97424 10.625 5.41992 10.625V11.375C8.38845 11.375 10.7949 8.96853 10.7949 6H10.0449ZM5.41992 10.625C2.8656 10.625 0.794922 8.55432 0.794922 6H0.0449219C0.0449219 8.96853 2.45139 11.375 5.41992 11.375V10.625ZM0.794922 6C0.794922 3.44568 2.8656 1.375 5.41992 1.375V0.625C2.45139 0.625 0.0449219 3.03147 0.0449219 6H0.794922ZM5.41992 1.375C7.97424 1.375 10.0449 3.44568 10.0449 6H10.7949C10.7949 3.03147 8.38845 0.625 5.41992 0.625V1.375ZM5.41992 10.625C5.24197 10.625 5.04287 10.5441 4.8291 10.3375C4.61352 10.1291 4.40224 9.80936 4.21668 9.38523C3.84605 8.53807 3.60742 7.3415 3.60742 6H2.85742C2.85742 7.41992 3.10848 8.72336 3.52957 9.68584C3.73987 10.1665 3.99996 10.5791 4.3078 10.8767C4.61744 11.176 4.99382 11.375 5.41992 11.375V10.625ZM3.60742 6C3.60742 4.6585 3.84605 3.46193 4.21668 2.61477C4.40224 2.19064 4.61352 1.87095 4.8291 1.66253C5.04287 1.45586 5.24197 1.375 5.41992 1.375V0.625C4.99382 0.625 4.61744 0.823964 4.3078 1.12332C3.99996 1.42093 3.73987 1.83347 3.52957 2.31416C3.10848 3.27664 2.85742 4.58008 2.85742 6H3.60742ZM5.41992 11.375C5.84603 11.375 6.2224 11.176 6.53204 10.8767C6.83988 10.5791 7.09998 10.1665 7.31028 9.68584C7.73136 8.72336 7.98242 7.41992 7.98242 6H7.23242C7.23242 7.3415 6.99379 8.53807 6.62316 9.38523C6.4376 9.80936 6.22633 10.1291 6.01075 10.3375C5.79697 10.5441 5.59788 10.625 5.41992 10.625V11.375ZM7.98242 6C7.98242 4.58008 7.73136 3.27664 7.31028 2.31416C7.09998 1.83347 6.83988 1.42093 6.53204 1.12332C6.2224 0.823964 5.84603 0.625 5.41992 0.625V1.375C5.59788 1.375 5.79697 1.45586 6.01075 1.66253C6.22633 1.87095 6.4376 2.19064 6.62316 2.61477C6.99379 3.46193 7.23242 4.6585 7.23242 6H7.98242ZM0.419922 6.375L10.1074 6.375V5.625L0.419922 5.625L0.419922 6.375Z'
        fill='#222124'
      />
    </svg>
  </SvgIcon>
)

const CodeValidationAgentDropdown = () => {
  const dispatch = useDispatch<any>()
  const selectedCodeValidationAgent = useSelector(
    (state: RootState) => state.validation.selectedCodeValidationAgent,
  )

  const [anchorEl, setAnchorEl] = useState<null | HTMLButtonElement>(null)
  const isOpen = Boolean(anchorEl)

  const handleClick = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }, [])

  const handleClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  const selectedDropdownItem = useMemo(() => {
    return (
      <Box
        sx={{
          padding: '4px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'left',
        }}
      >
        {CodeValidationAgentDropdownIcons[selectedCodeValidationAgent]}

        <Typography
          sx={{
            color: '#06004A',

            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
          }}
        >
          {selectedCodeValidationAgent}
        </Typography>
      </Box>
    )
  }, [selectedCodeValidationAgent])

  const handleButtonClick = useCallback(
    (agent: CodeValidationAgent) => {
      dispatch(setCodeValidationAgent({ agent }))

      handleClose()
    },
    [dispatch, handleClose],
  )

  const otherDropdownItems = useMemo(() => {
    return getEnums(CodeValidationAgent).reduce<JSX.Element[]>(
      (arr, current) => {
        const [key, mode] = current
        if (mode !== selectedCodeValidationAgent) {
          arr.push(
            <Fragment key={key}>
              <Button
                sx={{
                  padding: '4px',
                  display: 'flex',
                  flexDirection: 'row',
                  textTransform: 'none',
                  alignItems: 'center',
                  justifyContent: 'left',
                }}
                onClick={() => handleButtonClick(mode)}
              >
                {CodeValidationAgentDropdownIcons[mode]}

                <Typography
                  sx={{
                    color: '#06004A',

                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: 'normal',
                  }}
                >
                  {mode}
                </Typography>
              </Button>

              <Divider
                sx={{
                  marginX: '4px',
                }}
              />
            </Fragment>,
          )
        }

        return arr
      },
      [],
    )
  }, [selectedCodeValidationAgent, handleButtonClick])

  return (
    <>
      <Button
        size='small'
        disableRipple
        variant='outlined'
        onClick={handleClick}
        // endIcon={<ExpandMoreIcon />}
        disabled
        sx={{
          gap: '4px',
          padding: '0px',
          minWidth: '110px', // 155px
          marginRight: '8px',
          textTransform: 'none',
          justifyContent: 'space-between',
          '&.MuiButton-outlined': {
            backgroundColor: isOpen ? '#E5F0FF' : '#FFFFFF',
            border: '1px solid #E4E4E4',
          },
          '&.MuiButton-outlined:hover': {
            backgroundColor: '#E5F0FF',
          },
          '& .MuiButton-endIcon': {
            margin: 0,
            color: '#04002E',
            strokeWidth: '1px',
            rotate: isOpen ? '180deg' : '0deg',
          },
        }}
      >
        {selectedDropdownItem}
      </Button>
      <Popover
        id='code-validation-mode-dropdown'
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            minWidth: '155px',
            flexDirection: 'column',
            '& > .MuiDivider-root:last-of-type': {
              display: 'none',
            },
            '& > .MuiButton-root:hover + .MuiDivider-root, & > .MuiDivider-root:has(+ .MuiButton-root:hover)':
              {
                borderColor: '#E5F0FF',
                margin: 0,
              },
          }}
        >
          {otherDropdownItems}
        </Box>
      </Popover>
    </>
  )
}

const SpacialAI = () => {
  const dispatch = useDispatch<any>()

  const selectedCodeValidationResult = useSelector(
    (state: RootState) => state.validation.selectedCodeValidationRule,
  )
  const selectedCodeValidationElementResult = useSelector(
    (state: RootState) => state.validation.selectedCodeValidationRuleElement,
  )

  console.log('selectedCodeValidationResult', selectedCodeValidationResult)
  console.log(
    'selectedCodeValidationElementResult',
    selectedCodeValidationElementResult,
  )
  const handleShowOptionsButtonClick = useCallback(() => {
    dispatch(setShowCodeValidationOptionsModal(true))
  }, [dispatch])

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        right: 0,
        zIndex: 10000,
        width: 350,
        height: 420,
        boxShadow: 3,
        borderRadius: 2,
        bgcolor: 'white',
      }}
    >
      <Box
        sx={{
          gap: '4px',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          backgroundColor: '#FFFFFF',
          borderRadius: '2px',
          borderTop: '4px solid #CDF765',
        }}
      >
        {selectedCodeValidationResult && (
          <Box
            sx={{
              cursor: 'move',
              gap: '8px',
              display: 'flex',
              padding: '12px 6px',
              flexDirection: 'row',
              borderRadius: '2px',
              marginRight: '12px',
              marginLeft: '6px',
              border: '1px solid',
              borderLeftWidth: '7px',
              borderColor: selectedCodeValidationResult.status
                ? CodeValidationStatusColor[selectedCodeValidationResult.status]
                : '#FF0000',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '8px',
                }}
              >
                <Typography
                  sx={{
                    textAlign: 'left',
                    color: '#04002E',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                  }}
                >
                  {selectedCodeValidationResult.codeReference}
                </Typography>
              </Box>

              <Typography
                sx={{
                  textAlign: 'left',
                  color: '#04002E',
                  fontSize: '12px',
                  fontStyle: 'normal',
                  fontWeight: 600,
                  lineHeight: '14px',
                }}
              >
                {selectedCodeValidationResult.description}
              </Typography>
            </Box>
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            backgroundColor: '#F5F5F5',
            justifyContent: 'space-between',
            padding: '4px 4px 4px 12px',
            alignItems: 'center',
          }}
        >
          <SpacialAILogoSvgIcon />

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <CodeValidationAgentDropdown />

            <Divider
              flexItem
              orientation='vertical'
              sx={{
                borderRightWidth: '1px',
                borderColor: '#E4E4E4',
              }}
            />

            <IconButton>
              <EllipsisSvgIcon />
            </IconButton>
          </Box>
        </Box>

        <Box
          sx={{
            padding: '8px 0px 8px 8px',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
              padding: '12px 4px 12px 8px',
              gap: '8px',
              '&::-webkit-scrollbar': {
                width: '12px',
              },
              '&::-webkit-scrollbar-thumb': {
                borderRadius: '8px',
                backgroundColor: '#BBBCBC',
                backgroundClip: 'padding-box',
                border: '4px solid transparent',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: 'transparent',
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '4px',
              }}
            >
              <SpacialAISvgIcon fill='#3F69FF' width={9} height={10} />

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '6px',
                }}
              >
                <Typography
                  sx={{
                    textAlign: 'left',
                    color: '#04002E',
                    fontSize: '11px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: '12px',
                  }}
                >
                  {selectedCodeValidationResult?.description}
                </Typography>

                <Typography
                  sx={{
                    textAlign: 'left',
                    color: '#04002E',

                    fontSize: '10px',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    lineHeight: '12px',
                    textDecorationLine: 'underline',
                    textDecorationStyle: 'solid',
                    textDecorationSkipInk: 'none',
                    textDecorationThickness: 'auto',
                    textUnderlineOffset: 'auto',
                    textUnderlinePosition: 'from-font',
                  }}
                >
                  Key requirements:
                </Typography>

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '2px',
                  }}
                >
                  {selectedCodeValidationResult?.atomics.map(
                    (atomic, index) => (
                      <Typography
                        key={atomic.id}
                        sx={{
                          textAlign: 'left',
                          color: '#04002E',

                          fontSize: '10px',
                          fontStyle: 'normal',
                          fontWeight: 400,
                          lineHeight: '12px',
                        }}
                      >
                        {`${index + 1}. ${atomic.description}`}
                      </Typography>
                    ),
                  )}
                </Box>

                <Button
                  disabled={!selectedCodeValidationResult?.elementsIds?.length}
                  disableElevation
                  variant='contained'
                  onClick={handleShowOptionsButtonClick}
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '8px',
                    maxWidth: '120px',
                    textTransform: 'none',
                    height: '24px',
                    '&.MuiButton-contained': {
                      backgroundColor: '#CDF765',
                      borderRadius: '4px',
                    },
                  }}
                >
                  <SpacialAISvgIcon fill='#04002E' width={9} height={10} />

                  <Typography
                    sx={{
                      color: '#04002E',
                      fontSize: '6px',

                      fontStyle: 'normal',
                      fontWeight: 500,
                      lineHeight: '8px',
                    }}
                  >
                    Show Options
                  </Typography>
                </Button>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              marginRight: '12px',
              borderRadius: '4px',
              backgroundColor: '#F2F2F2',
              padding: '4px 0px 4px 4px',
            }}
          >
            <TextField
              multiline
              rows={1}
              placeholder='Add a comment'
              variant='standard'
              sx={{
                padding: '8px',
                bottom: '2px',
              }}
            />

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '8px',
                }}
              >
                <IconButton disabled>
                  <PhotoSvgIcon />
                </IconButton>

                <IconButton disabled>
                  <LinkSvgIcon />
                </IconButton>

                <IconButton disabled>
                  <GlobeSvgIcon />
                </IconButton>
              </Box>

              <IconButton disabled>
                <EnterSvgIcon />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default SpacialAI
